import React from 'react'
import { AspectRatio, Box, Flex, Text } from '@chakra-ui/react'
import Image from 'next/image'
import Link from 'next/link'

const WhereToBuyItem = ({
  href,
  icon,
  alt
}: {
  href: string
  icon: string
  alt: string
}) => {
  const width = {
    md: 28,
    base: 20
  }

  return (
    <Link href={href} target="_blank">
      <AspectRatio width={width} ratio={1 / 1} position="relative">
        <Image src={icon} alt={alt} fill />
      </AspectRatio>
    </Link>
  )
}

const WhereToBuy = () => {
  const items = [
    {
      href: 'https://habbit.sg/products/doctorcos-snow-white-water-glow-mask?utm_source=dcsite&utm_medium=button&utm_campaign=DCmicrosite&utm_id=DC+microsite+button',
      icon: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/habbit-logo-1713522234214.png',
      alt: 'Habbit logo'
    },
    {
      href: 'https://www.jml.sg/sg/products/doctorcos-snow-white-water-glow-mask?utm_source=dcsite&utm_medium=button&utm_campaign=DCmicrosite&utm_id=DC+microsite+button',
      icon: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/jml-logo-1713522234214.png',
      alt: 'JML logo'
    },
    {
      href: 'https://shopee.sg/universal-link/product/236618592/18034968081/?deep_and_web=1&utm_campaign=s236618592_ss_sg_orgn_doctorcosmicrositebutton&utm_source=others&utm_medium=seller&utm_content=dcsitebutton&smtt=9',
      icon: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/shopee-logo-1713522234215.png',
      alt: 'Shopee logo'
    },
    {
      href: 'https://c.lazada.sg/t/c.YlOinO?intent=false&fallback=true&url=https%3A%2F%2Fwww.lazada.sg%2Fproducts%2Fi2441267832.html%3Fspm%3Da1zawe.24863640.table_online_product.23.35084edf0QzLPe',
      icon: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/lazada-logo-1713522234214.png',
      alt: 'Lazada logo'
    },
    {
      href: 'https://qrs.ly/mdfw6x2',
      icon: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/qoo1O-1718869409708.png',
      alt: 'qoo1O logo'
    },
    {
      href: 'https://qrs.ly/srfw6x5',
      icon: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/wonder-1711598628576.png',
      alt: 'Wonder logo'
    },
    {
      href: 'https://qrs.ly/93fw9y6',
      icon: 'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/ntuc-1718869409705.png',
      alt: 'NTUC logo'
    }
  ]

  return (
    <Box>
      <Text
        textStyle="docMainTitle"
        textTransform="uppercase"
        textAlign="center"
      >
        Where to buy
      </Text>

      <Box
        maxWidth={{
          md: 592,
          base: 'none'
        }}
        margin="0 auto"
      >
        <Flex
          mt={{
            md: 8,
            base: 4
          }}
          flexWrap="wrap"
          gap={{
            md: 12,
            base: 6
          }}
          justifyContent={{
            md: 'flex-start',
            base: 'center'
          }}
        >
          {items.map((item, index) => (
            <WhereToBuyItem key={`where-to-buy-item-${index}`} {...item} />
          ))}
        </Flex>
      </Box>
    </Box>
  )
}

export default WhereToBuy
